import { getTableRowAsObject } from '@loaders.gl/schema';
import { getRowPropertyObject } from "./encode-utils.js";
export function encodeTableRow(table, rowIndex, geometryColumnIndex, utf8Encoder) {
  const row = getTableRowAsObject(table, rowIndex);
  if (!row) return;
  const featureWithProperties = getFeatureFromRow(table, row, geometryColumnIndex);
  const featureString = JSON.stringify(featureWithProperties);
  utf8Encoder.push(featureString);
}
function getFeatureFromRow(table, row, geometryColumnIndex) {
  var _table$schema, _featureOrGeometry, _featureOrGeometry2;
  const properties = getRowPropertyObject(table, row, [geometryColumnIndex]);
  const columnName = (_table$schema = table.schema) === null || _table$schema === void 0 ? void 0 : _table$schema.fields[geometryColumnIndex].name;
  let featureOrGeometry = columnName && row[columnName];
  if (!featureOrGeometry) {
    return {
      type: 'Feature',
      geometry: null,
      properties
    };
  }
  if (typeof featureOrGeometry === 'string') {
    try {
      featureOrGeometry = JSON.parse(featureOrGeometry);
    } catch (err) {
      throw new Error('Invalid string geometry');
    }
  }
  if (typeof featureOrGeometry !== 'object' || typeof ((_featureOrGeometry = featureOrGeometry) === null || _featureOrGeometry === void 0 ? void 0 : _featureOrGeometry.type) !== 'string') {
    throw new Error('invalid geometry column value');
  }
  if (((_featureOrGeometry2 = featureOrGeometry) === null || _featureOrGeometry2 === void 0 ? void 0 : _featureOrGeometry2.type) === 'Feature') {
    return {
      ...featureOrGeometry,
      properties
    };
  }
  return {
    type: 'Feature',
    geometry: featureOrGeometry,
    properties
  };
}
//# sourceMappingURL=encode-table-row.js.map